module.exports = __webpack_public_path__ + "img/stage-7-animated.a12ea666.png";